//-----------------------------------------------------------------------------
// economy
//-----------------------------------------------------------------------------

import { Tier } from './interfaces';

export enum Currency {
	SILVER = 'silver',
	GOLD = 'gold',
}

export interface Wallet {
	userId: string;
	silver: number;
	gold: number;
	silverRefill: Date | null;
	goldRefill: Date | null;
	updatedAt: Date;
}

export interface RefillPolicy {
	tier: number;
	silverRefill: number;
	silverEraHours: number;
	goldRefill: number;
	goldEraHours: number;
}

// constants used to fine-tune the economy
// even though some of these are forge-only or studio-only, we'll keep them here
// so everything can be managed in one place

export const WALLET_INITIAL_VALUES: Record<Currency, number> = {
	[Currency.SILVER]: 100,
	[Currency.GOLD]: 50,
};

export const LOW_THRESHOLD = 15;

export const REFILL_POLICIES: Record<number, RefillPolicy> = {
	0: {
		tier: 0,
		silverRefill: 30,
		silverEraHours: 16,
		goldRefill: 20,
		goldEraHours: 120,
	},
	1: {
		tier: 1,
		silverRefill: 100,
		silverEraHours: 16,
		goldRefill: 75,
		goldEraHours: 120,
	},
	2: {
		tier: 2,
		silverRefill: 150,
		silverEraHours: 16,
		goldRefill: 100,
		goldEraHours: 16,
	},
};

// Amount of gold user is given when they opt to refill manually
export const GOLD_REFILL_AMOUNTS: Record<Tier, number> = {
	[Tier.FREE]: 20,
	[Tier.TIER_1]: 50,
	[Tier.TIER_2]: 100, // TIER_2 users should have unlimited gold, but putting this here just in case for completeness
};

// Maximum number of bonus refills a user can perform
export const MAX_BONUS_REFILLS = 3;
